import { render, staticRenderFns } from "./ImportUpload.vue?vue&type=template&id=6b3fa7c9&scoped=true&"
import script from "./ImportUpload.vue?vue&type=script&lang=js&"
export * from "./ImportUpload.vue?vue&type=script&lang=js&"
import style0 from "./ImportUpload.vue?vue&type=style&index=0&id=6b3fa7c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3fa7c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDivider,VIcon,VSimpleTable})
